// src/pages/admin/users/components/UserActionsCell.js
import React from 'react';
import { FiEye, FiTrash2, FiPauseCircle } from 'react-icons/fi';

const UserActionsCell = ({ user, handleView, handleDelete, handleSuspend }) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', width: '100%', margin: '0 auto' }}>
            {/* ✅ VIEW BUTTON: ROYAL BLUE */}
            <button
                type="button"
                style={{
                    background: '#2563eb',
                    backgroundColor: '#2563eb',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '6px',
                    width: '32px',
                    height: '32px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    padding: 0,
                    flexShrink: 0
                }}
                onClick={() => handleView(user.id)}
                title="View User"
            >
                <FiEye size={15} color="#ffffff" />
            </button>

            {/* ✅ DELETE BUTTON: CRIMSON RED */}
            <button
                type="button"
                style={{
                    background: '#dc2626',
                    backgroundColor: '#dc2626',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '6px',
                    width: '32px',
                    height: '32px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    padding: 0,
                    flexShrink: 0
                }}
                onClick={() => handleDelete(user.id)}
                title="Delete User"
            >
                <FiTrash2 size={15} color="#ffffff" />
            </button>

            {/* ✅ SUSPEND/UNSUSPEND BUTTON: AMBER / SLATE */}
            <button
                type="button"
                style={{
                    background: user.is_suspended ? '#d97706' : '#4b5563',
                    backgroundColor: user.is_suspended ? '#d97706' : '#4b5563',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '6px',
                    width: '32px',
                    height: '32px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    padding: 0,
                    flexShrink: 0
                }}
                onClick={() => handleSuspend(user.id)}
                title={user.is_suspended ? "Unsuspend User" : "Suspend User"}
            >
                <FiPauseCircle size={15} color="#ffffff" />
            </button>
        </div>
    );
};

export default UserActionsCell;
